import { useRef } from 'react';

import { Button } from 'design-system';
import { ChevronRightIcon } from 'lucide-react';

import { useDisclosure } from '@/shared/hooks/useDisclosure';

import { FeedArticleDialog } from './FeedArticleDialog';

export const FeedArticleDialogLink = ({
  CTAValue,
  CTALabel
}: {
  CTAValue: string;
  CTALabel?: string;
}) => {
  const { isOpen, open, close } = useDisclosure();
  const [groupName, fileName] = CTAValue.split('/');
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        ref={triggerRef}
        data-ph-capture-attribute-component-type='feed-article'
        data-ph-capture-attribute-file-name={fileName}
        data-ph-capture-attribute-group-name={groupName}
        variant='link'
        onClick={open}
      >
        {CTALabel ?? 'See the article'}
        <ChevronRightIcon aria-hidden='true' />
      </Button>
      <FeedArticleDialog
        CTAValue={CTAValue}
        finalFocusRef={triggerRef}
        open={isOpen}
        onClose={close}
      />
    </>
  );
};
